/**
 * 재사용 가능한 확인/취소 다이얼로그 플러그인
 * 사용자 확인이 필요한 액션에 사용
 *
 * 사용 예시:
 * <div x-data="confirmDialog">
 *     <button @click="confirm('삭제하시겠습니까?', '이 작업은 취소할 수 없습니다.', () => { console.log('삭제됨') })">
 *         삭제
 *     </button>
 * </div>
 *
 * @returns {{isOpen: boolean, title: string, message: string, confirmCallback: null, confirm(string, string, function): void, handleConfirm(): void, handleCancel(): void}}
 */
export default () => ({
    dialogIsOpen: false,
    title: '',
    message: '',
    confirmCallback: null,
    callback: '',
    dialogType: '',
    // 2025.10.24 추가
    closeOnBackdrop: true,       // 배경 클릭시 닫기
    closeOnEscape: true,         // ESC 키로 닫기

    /**
     * 확인 다이얼로그 열기
     * @param {string} title - 다이얼로그 제목
     * @param {string} message - 확인 메시지
     * @param {string} dialogType - 'base', 'success', 'info', 'warning', 'danger'
     * @param {Object} options - 옵션
     * @param {boolean} options.closeOnBackdrop - 배경 클릭시 닫기 여부
     * @param {boolean} options.closeOnEscape - ESC 키로 닫기 여부
     * @param {function} callback - 확인 버튼 클릭시 실행할 콜백 함수
     */
    confirm(title = '', message = '', dialogType = 'base', options = {}, callback) {
        this.title = title;
        this.message = message;
        this.dialogType = dialogType; // 'base', 'success', 'info', 'warning', 'danger'
        this.confirmCallback = callback;

        // 옵션 적용
        if (options.closeOnBackdrop !== undefined) this.closeOnBackdrop = options.closeOnBackdrop;
        if (options.closeOnEscape !== undefined) this.closeOnEscape = options.closeOnEscape;

        // 템플릿이 DOM에 삽입될 시간을 주기 위해 nextTick 사용
        this.$nextTick(() => {
            this.dialogIsOpen = true;
            document.body.style.overflow = 'hidden';
        });

    },

    /**
     * 확인 버튼 클릭 핸들러
     */
    handleConfirm() {
        if (typeof this.confirmCallback === 'function') {
            this.confirmCallback();
        }
        this.closeDialog();
    },

    /**
     * 취소 버튼 클릭 핸들러
     */
    handleCancel() {
        this.closeDialog();
    },

    /**
     * 배경 클릭 핸들러 - 2025.10.24 추가
     * simpleModal과 충돌 방지를 위해 handleDialogBackdropClick로 명명
     */
    handleDialogBackdropClick() {
        if (this.closeOnBackdrop) {
            this.closeDialog();
        }
    },

    /**
     * ESC 키 핸들러
     * simpleModal과 충돌 방지를 위해 handleDialogEscape로 명명
     */
    handleDialogEscape() {
        if (this.closeOnEscape) {
            this.closeDialog();
        }
    },

    /**
     * 다이얼로그 닫기
     * simpleModal과 충돌 방지를 위해 closeDialog로 명명
     */
    closeDialog() {
        this.title = '';
        this.message = '';
        this.confirmCallback = null;
        this.closeOnBackdrop = true;
        this.closeOnEscape = true;
        this.dialogType = '';  // 다이얼로그 타입 초기화

        // 처음 1회 닫힐때 깜빡임을 없애기 위해 종료 시간을 조금 늦춰줌.
        this.$nextTick(() => {
            this.dialogIsOpen = false;
            document.body.style.overflow = ''; // 스크롤 복원
        });
    }
});
